import React from 'react'
import { useUser } from '@fs/zion-user'
import usePerson from '../../services/usePerson'
import WelcomeBanner from './WelcomeBanner'

export default function AncestorsPageHeader(): JSX.Element {
  const person = usePerson()
  const { signedIn } = useUser()
  const showWelcomeBanner = signedIn
  const analytics = { link_app: 'tree-ancestors-r9', link_page: 'Person' }

  return <div>{showWelcomeBanner && <WelcomeBanner person={person} analytics={analytics} />}</div>
}
